import { render, staticRenderFns } from "./MerchantReturnPoints.vue?vue&type=template&id=24d458d0"
import script from "./MerchantReturnPoints.vue?vue&type=script&lang=js"
export * from "./MerchantReturnPoints.vue?vue&type=script&lang=js"
import style0 from "./MerchantReturnPoints.vue?vue&type=style&index=0&id=24d458d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports